import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { ProductEnvironment } from '@atlassian/forge-ui-types';
import ErrorPanel from '../components/UIKit1/errorPanel/errorPanel';
import { captureAndReportError } from '../error-reporting';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { FORGE_UI_ANALYTICS_CHANNEL } from '../analytics';
import { MetricsContext } from '../context';
export var ComponentError = /*#__PURE__*/function (_Error) {
  function ComponentError(message, component) {
    var _this;
    _classCallCheck(this, ComponentError);
    _this = _callSuper(this, ComponentError, [message]);
    _this.component = component;
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(_this, ComponentError.prototype);
    return _this;
  }
  _inherits(ComponentError, _Error);
  return _createClass(ComponentError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ComponentErrorBoundaryWithCreateAnalyticsEvent = /*#__PURE__*/function (_Component) {
  function ComponentErrorBoundaryWithCreateAnalyticsEvent() {
    var _this2;
    _classCallCheck(this, ComponentErrorBoundaryWithCreateAnalyticsEvent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ComponentErrorBoundaryWithCreateAnalyticsEvent, [].concat(args));
    _defineProperty(_this2, "state", {
      thrownError: undefined
    });
    return _this2;
  }
  _inherits(ComponentErrorBoundaryWithCreateAnalyticsEvent, _Component);
  return _createClass(ComponentErrorBoundaryWithCreateAnalyticsEvent, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _extension$appOwner;
      // Filters out reporting errors for components that are not valid e.g. <Buton/>
      if (!(error instanceof ComponentError)) {
        throw error;
      }
      var extension = this.props.extension;
      var _this$context = this.context,
        page = _this$context.page,
        environment = _this$context.environment;
      captureAndReportError({
        error: error,
        errorInfo: errorInfo,
        page: page,
        environment: environment !== null && environment !== void 0 ? environment : ProductEnvironment.DEVELOPMENT,
        errorExtensionDetails: extension ? {
          type: extension.type,
          environmentType: extension.environmentType,
          appOwnerAccountId: (_extension$appOwner = extension.appOwner) === null || _extension$appOwner === void 0 ? void 0 : _extension$appOwner.accountId,
          properties: extension.properties,
          id: extension === null || extension === void 0 ? void 0 : extension.id
        } : undefined
      });
      this.props.createAnalyticsEvent({
        eventType: OPERATIONAL_EVENT_TYPE,
        data: {
          action: 'failed',
          actionSubject: 'forge.ui.renderer',
          source: page,
          tags: ['forge'],
          attributes: {
            target: 'errorBoundary',
            errorName: 'componentError',
            component: error.component
          }
        }
      }).fire(FORGE_UI_ANALYTICS_CHANNEL);
      this.setState({
        thrownError: {
          error: error,
          errorInfo: errorInfo
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var thrownError = this.state.thrownError;
      if (!thrownError) {
        return this.props.children;
      }
      return /*#__PURE__*/React.createElement(ErrorPanel, {
        error: thrownError.error,
        dispatch: this.props.dispatch
      });
    }
  }]);
}(Component);
_defineProperty(ComponentErrorBoundaryWithCreateAnalyticsEvent, "contextType", MetricsContext);
var ComponentErrorBoundary = function ComponentErrorBoundary(props) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return /*#__PURE__*/React.createElement(ComponentErrorBoundaryWithCreateAnalyticsEvent, _extends({}, props, {
    createAnalyticsEvent: createAnalyticsEvent
  }));
};
export default ComponentErrorBoundary;